export default "__VITE_ASSET__ro4tomFB__"